export const networkStatuses = [
  'previous-gamstop',
  'self-excluded',
  'suspended',
  'kyc-fail',
  'risk',
  'fraud',
  'time-out',
  'previously-excluded',
  'national-register-excluded',
  'active-bonus-restricted',
  'social-responsibility-risk',
  'ok',
]
